// @flow

import React, { type Node, useEffect } from 'react';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { BankList } from './bank-list';
import { InputColombianAddress } from '../../customer/colombian';
import { InputHolder } from '../../commons';
import {
  getSafePaymentOptionsV2,
  useOpenedIncomingPayment,
} from '@tectonics/prs/incoming-payment';
import { getSafeExternalPayProviderPaymentOption } from '@tectonics/prs/incoming-payment/payment-option';
import { Empty } from '@tectonics/components';

export function AchPseForm(): Node {
  const allFeatures = useAllFeatures();
  const [selectedExternalPayProvider, setSelectedExternalPayProvider] = useUserInputValue('selectedExternalPayProvider');

  useEffect(() => {
    setSelectedExternalPayProvider('achpse');
  }, [selectedExternalPayProvider]);

  return(
    <>
      <IfFeature allFeatures={allFeatures} wanted="field_colombian_address">
        <InputHolder>
          <InputColombianAddress />
        </InputHolder>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_externalpayprovider_bank_list">
        <BankList />
      </IfFeature>
    </>
  );
}

export function ExternalPaymentProviderFormDeciderForColombia(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  let checkoutPaymentOptions = getSafePaymentOptionsV2(incomingPayment);
  const externalpayproviderAllowedOptions = getSafeExternalPayProviderPaymentOption(checkoutPaymentOptions);
  if (externalpayproviderAllowedOptions.filter((option) => option.value === 'achpse').length === 0) {
    return (<Empty />);
  }

  return <AchPseForm />;
}
